import axios from "axios";
import { StorageService } from "../config/storage";

// Create an instance of axios
const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL, // Set your base URL here
  timeout: 30000, // Set a timeout limit (ms)
});

// Request interceptor to add the auth token to headers
httpClient.interceptors.request.use(
  (config) => {
    config.headers["X-API-Key"] = "gj08kDqkn26W1d6fWlgA9O9fAkV3I7wq";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Server responded with a status other than 2xx
      if (error.response.status === 401) {
        // Handle unauthorized access (e.g., redirect to login)
        window.location.href = "/login";
      }
      // Add other status code handling if needed
    } else if (error.request) {
      // Request was made but no response received
      console.error("No response received:", error.request);
    } else {
      // Something happened in setting up the request
      console.error("Error setting up request:", error.message);
    }
    return Promise.reject(error);
  }
);

export default httpClient;
